import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../utils/hooks/useIsMobile';
import { submitEventLead } from '../../utils/api/inquiryApi';
import s from '../../styles/components/booking/BookingForm.module.css';
import site from '../../data/master.json';

export default function BookingForm() {
  const b = site.booking;
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    date: '', location: '', type: '', budget: '', name: '', phone: '',
  });
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(false);
    try {
      await submitEventLead(form);
      navigate('/faq');
    } catch (err) {
      console.error(err);
      setError(true);
      setSending(false);
    }
  };

  return (
    <section className={isMobile ? s.containerMobile : s.container}>
      <div className={isMobile ? s.mediaMobile : s.media}>
        <img src={b.image} alt={b.imageAlt} className={s.image} />
      </div>

      <form className={isMobile ? s.formColMobile : s.formCol} onSubmit={handleSubmit}>
        <span className={s.eyebrow}>{b.eyebrow}</span>
        <h1 className={s.headline}>{b.headline}</h1>
        <p className={s.subhead}>{b.subhead}</p>

        <fieldset className={s.group}>
          <label className={s.field}>
            <span className={s.label}>{b.labels.date}</span>
            <input className={s.input} type="date" value={form.date} onChange={set('date')} required />
          </label>

          <label className={s.field}>
            <span className={s.label}>{b.labels.type}</span>
            <input className={s.input} type="text" placeholder={b.placeholders.type} value={form.type} onChange={set('type')} required />
          </label>

          <label className={s.field}>
            <span className={s.label}>{b.labels.location}</span>
            <input className={s.input} type="text" placeholder={b.placeholders.location} value={form.location} onChange={set('location')} required />
          </label>

          <label className={s.field}>
            <span className={s.label}>{b.labels.budget}</span>
            <select className={s.input} value={form.budget} onChange={set('budget')} required>
              <option value="" disabled>{b.budgetPlaceholder}</option>
              {b.budgetOptions.map((o) => <option key={o} value={o}>{o}</option>)}
            </select>
          </label>
        </fieldset>

        <fieldset className={s.group}>
          <p className={s.note}>{b.contactNote}</p>

          <label className={s.field}>
            <span className={s.label}>{b.labels.name}</span>
            <input className={s.input} type="text" placeholder={b.placeholders.name} value={form.name} onChange={set('name')} required />
          </label>

          <label className={s.field}>
            <span className={s.label}>{b.labels.phone}</span>
            <input className={s.input} type="tel" placeholder={b.placeholders.phone} value={form.phone} onChange={set('phone')} required />
          </label>
        </fieldset>

        {error && <p className={s.error}>Something went wrong. Please try again.</p>}

        <button type="submit" className={s.btn} disabled={sending}>{b.submitBtn}</button>
      </form>
    </section>
  );
}